import styled, { useTheme } from 'styled-components/macro';

import { Label, SubLabel } from '../../SubComponents/Text';
import { Button } from '../../SubComponents/Buttons';
import { DockingLocationProps } from '.';
import useTypeSafeLocalize from '../../Hooks/use-type-safe-localize';
import { LocalizationCategory, ProductLocalization } from '../../localizations/types';

const DefaultDockingLocationContainer = styled.div<{ selected: boolean }>`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 32px;
  padding: 16px 32px;
  background-color: ${(props) =>
    props.selected ? props.theme.colors.buttons.primary.backgroundColor : '#fff'};
  border-radius: 4px;

  @media (min-width: 768px) {
    padding: 32px;
  }
`;

const DefaultDockingLocationContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  cursor: pointer;
`;

export const DockingLocationAddress = styled(SubLabel)<{ selected: boolean }>`
  cursor: pointer;
  text-decoration: underline;
  transition: color 0.2s ease-in-out;

  :hover {
    color: ${(props) => (props.selected ? '#c8ccd4' : '#626c80')};
  }
`;

const DefaultDockingLocation = (props: DockingLocationProps) => {
  const localize = useTypeSafeLocalize();
  const theme = useTheme();

  if (!props.dockingLocation?.id) return null;

  return (
    <DefaultDockingLocationContainer selected={props.selected}>
      <a
        href={props.mapLink}
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: 'none' }}
      >
        <DefaultDockingLocationContentContainer>
          <Label
            color={props.selected ? '#fff' : theme.textColor}
            style={{ cursor: 'pointer' }}
          >
            {props.dockingLocation.name}
          </Label>
          <DockingLocationAddress selected={props.selected}>
            {props.dockingLocation.address}
          </DockingLocationAddress>
        </DefaultDockingLocationContentContainer>
      </a>

      <div>
        <Button
          style={{
            border: props.selected ? '1px solid #C7C7C7' : 'none',
            fontSize: props.selected ? '1.4rem' : '1.6rem',
          }}
          onClick={() =>
            props.dockingLocation ? props.setSelected(props.dockingLocation.id) : null
          }
        >
          {props.selected
            ? localize(LocalizationCategory.product, ProductLocalization.includedInPrice)
            : localize(LocalizationCategory.product, ProductLocalization.select)}
        </Button>
      </div>
    </DefaultDockingLocationContainer>
  );
};

export default DefaultDockingLocation;
